import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { AlertCircle } from 'lucide-react';
import { DeleteDialogProps } from '../@types/props.types';

const DeleteDialog = ({ isOpen, onClose, onConfirm }: DeleteDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose} className="rounded-lg m-3 p-3">
      <DialogContent className="rounded-lg sm:max-w-[425px]">
        <DialogHeader className="flex flex-col items-center gap-2">
          <div className="rounded-full bg-red-50 p-3">
            <AlertCircle className="h-6 w-6 text-red-500" />
          </div>
          <DialogTitle className="text-xl">Подтверждение отмены</DialogTitle>
          <DialogDescription className="text-center text-gray-500">
            Вы уверены, что хотите отменить это занятие? Это действие нельзя будет отменить.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4 flex gap-2 sm:gap-0">
          <Button variant="outline" className="flex-1 sm:flex-none" onClick={onClose}>
            Отмена
          </Button>
          <Button
            variant="destructive"
            className="flex-1 bg-red-500 hover:bg-red-600 sm:flex-none"
            onClick={onConfirm}>
            Подтвердить
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDialog;
